import axios from "axios";
import { useQuery } from "react-query";
import { config } from "../../utils/conf";
import { requestHeaders } from "../../utils/http";
import useSession from "../Auth/useSession";

export default function useGetOrderStatuses() {
  const { accessToken } = useSession();
  const queryId = accessToken ? "order-statuses" : "order-statuses-no-token";
  const url = `${config.orderApiUrl}/v1/order-statuses`;

  return useQuery(
    [queryId],
    async () => {
      const response = await axios.get(url, {
        headers: requestHeaders(accessToken),
      });
      console.log("Fetched statuses response:", response.data);
      return response;
    },
    {
      select: (response) => {
        const rawData = response?.data || {};
        return Object.entries(rawData).map(([key, value]) => ({
          label: value.Value || key,
          value: key,
          ...value,
        }));
      },
    },
  );
}
